import React from "react";
import "./App.css";
import AuthRoutes from "./components/AuthRoutes";
import { AuthContext } from "./context/AuthState";

import requests from "./lib/requests";
import Toast from "./components/Toast";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  const { setUser, logOut } = React.useContext(AuthContext);

  const authUserToken = React.useCallback(async () => {
    try {
      // Validate token from backend
      const resData = await (await requests.get("/auth/user")).data;

      if (!resData.data) {
        throw new Error();
      }
      setUser(resData.data);
    } catch (error) {
      logOut();
      // remove token when validation fails
    }
  }, []);
  React.useEffect(() => {
    authUserToken();
  }, []);
  return (
    <ErrorBoundary>
      <AuthRoutes />
      <Toast />
    </ErrorBoundary>
  );
}

export default App;
